export type Opaque = 'white' | 'grey';

export function opaqueClassName(value?: Opaque) {
  return value && `n--opaque-${value}`;
}
